import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import axios from './utils/axios'

// 组件
import Header from "./components/Header.vue"


const app = createApp(App)
app.use(store)
app.use(router)
app.use(axios)
app.use(ElementPlus, { locale: zhCn })
// 全局公共组件
app.component('Header',Header)
app.mount('#app')
